<div class="modal-header" style="display:flex;" appCustomAutofocus>
    <h3 class="modal-title">Note - {{data.FirstName}} {{data.LastName}}</h3>
    <div style="margin-top:10px;">
        <span *ngIf="lastSave.status && lastSave.time != null" class="badge badge-success default" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;">Save Successful - {{lastSave.time}}</span>
        <span *ngIf="!lastSave.status && lastSave.time != null" class="badge badge-danger default" [ngClass]="{fade: formData.labelFade}" style="margin-left:25px;">Save Fail - {{lastSave.time}}</span>
    </div>
</div>
<div class="modal-body">

    <ul style="list-style:none;padding-left:0px;margin-top:25px;" *ngIf="noteList?.length > 0">
        <li class="row">
            <div class="col-lg-2 col-md-2 col-2">
                <strong>Date</strong>
            </div>
            <div class="col-lg-2 col-md-2 col-2">
                <strong>Author</strong>
            </div>
            <div class="col-lg-5 col-md-5 col-5">
                <strong>Notes</strong>
            </div>
            <div class="col-lg-3 col-md-3 col-3" *ngIf="!viewMode">
            </div>
        </li>
        <div style="border-top: 1px solid #eee;margin-bottom:10px;"></div>
        <div style="max-height:400px;overflow-x:hidden;">
        <li *ngFor="let data of noteList" style="margin-bottom:5px;">
            <div *ngIf="!data.remove" class="row">
                <div class="col-lg-2 col-md-2 col-2">
                    {{data.DateAdded}}
                </div>
                <div class="col-lg-2 col-md-2 col-2">
                    {{data.UserFullName}}
                </div>
                <div class="col-lg-5 col-md-5 col-5">
                    <span *ngIf="!data.editing">{{data.NoteText}}</span>
                </div>
                <div class="col-lg-3 col-md-3 col-3" *ngIf="!viewMode">
                    <button class="btn btn-outline-dark" type="button" (click)="editNote(data)" *ngIf="employeeInfo.UserKeyID == data.AddedByUserKeyID && !data.editing">Edit</button>
                    <button class="btn btn-outline-dark" type="button" (click)="removeNote(data)" style="color:red;" *ngIf="employeeInfo.UserKeyID == data.AddedByUserKeyID && !data.editing">
                        <span>
                            <i class="modus-icons align-bottom">close</i>   <!--check glyphicon-remove -->
                        </span>
                    </button>
                </div>
            </div>
            <div *ngIf="data.remove" class="row">
                <div class="col-lg-9 col-md-9 col-9">
                    <span style="color:red;">Are you sure you want to delete this note?</span>
                </div>
                <div class="col-lg-3 col-md-3 col-3">
                    <button class="btn btn-outline-dark" type="button" (click)="removeNoteConfirm(data)" style="color:green;">Yes</button>
                    <button class="btn btn-outline-dark" type="button" (click)="removeNoteCancel(data)" style="color:red;">No</button>
                </div>
            </div>
            <div *ngIf="data.editing">
                <br />
                <div class="bg-light" style="margin-left:0px;margin-right:0px;margin-top:10px;padding-left:15px;padding-right:0px;">
                    <div class="card card-md bg-light" style="padding-left:0px;padding-right:1px;margin-left:0px;margin-right:0px;padding-top: 9px; padding-bottom: 9px;">
                        <div class="row">
                            <div class="col-lg-9 col-md-9 col-9">
                                <textarea type="text" rows="4" class="form-control" style="resize:none;" [(ngModel)]="data.NoteText" (change)="updateTimeout()"></textarea>
                            </div>
                            <div class="col-lg-3 col-md-3 col-3">
                                <button class="btn btn-success" type="button" (click)="saveEdit(data)">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
</div>
<hr />
    </ul>

<div *ngIf="!viewMode">
    <strong>Add a Note:</strong>
    <textarea type="text" rows="4" class="form-control" style="resize:none;" [(ngModel)]="formData.newNote" (change)="updateTimeout()"></textarea>
</div>
</div>
<div class="modal-footer">
    <button *ngIf="!viewMode" type="button" class="btn btn-success" (click)="addClicked()" [disabled]="formData.newNote == null || formData.newNote === ''">Add</button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>